import axios from 'axios';
import { downloadFromS3 } from '@/helpers/axiosS3Downloader';

export const defaultState = {
  legalEntity: {
    list: [],
    listLoading: false,
  },
};

export const mutations = {
  LEGAL_ENTITY_SET_LIST(state, list) {
    state.legalEntity.list = list;
  },
  LEGAL_ENTITY_SET_LIST_LOADING(state, isLoading) {
    state.legalEntity.listLoading = isLoading;
  },
};

export const getters = {
  getLegalEntitiesList: state => state.legalEntity.list,
};

export const actions = {
  fetchPatLegalEntityList({ commit }) {
    commit('LEGAL_ENTITY_SET_LIST_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/legal-entity`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { legalEntities } = response;
          commit('LEGAL_ENTITY_SET_LIST_LOADING', false);
          commit('LEGAL_ENTITY_SET_LIST', legalEntities);
        });
      })
      .catch((error) => {
        commit('LEGAL_ENTITY_SET_LIST_LOADING', false);
        commit('LEGAL_ENTITY_SET_LIST', []);

        return Promise.reject(error);
      });
  },
  fetchPatLegalEntityAll({ dispatch }) {
    dispatch('fetchPatLegalEntityList');
  },
  createPatLegalEntity({ dispatch }, payload) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/legal-entity`, payload)
      .then((data) => {
        dispatch('fetchPatLegalEntityAll');

        return data;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
  updatePatLegalEntity({ dispatch }, payload) {
    const { id } = payload;

    return axios.put(`${window.BASE_API.PAYOUT_AND_TAXES}/legal-entity/${id}`, payload)
      .then((data) => {
        dispatch('fetchPatLegalEntityAll');

        return data;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
  deletePatLegalEntity({ dispatch }, id) {
    return axios.delete(`${window.BASE_API.PAYOUT_AND_TAXES}/legal-entity/${id}`)
      .then((data) => {
        dispatch('fetchPatLegalEntityAll');

        return data;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
};

const legalEntity = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default legalEntity;



// WEBPACK FOOTER //
// ./src/store/payout/legalEntity.js